import { render, staticRenderFns } from "./H5TabBar.vue?vue&type=template&id=cbdc44c0&scoped=true"
import script from "./H5TabBar.vue?vue&type=script&lang=js"
export * from "./H5TabBar.vue?vue&type=script&lang=js"
import style0 from "./H5TabBar.vue?vue&type=style&index=0&id=cbdc44c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdc44c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbdc44c0')) {
      api.createRecord('cbdc44c0', component.options)
    } else {
      api.reload('cbdc44c0', component.options)
    }
    module.hot.accept("./H5TabBar.vue?vue&type=template&id=cbdc44c0&scoped=true", function () {
      api.rerender('cbdc44c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/h5/H5TabBar.vue"
export default component.exports